import { render } from "./RegenerateKeyModal.vue?vue&type=template&id=5240ad84&scoped=true&lang=pug"
import script from "./RegenerateKeyModal.vue?vue&type=script&lang=js"
export * from "./RegenerateKeyModal.vue?vue&type=script&lang=js"

import "./RegenerateKeyModal.vue?vue&type=style&index=0&id=5240ad84&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5240ad84"]])

export default __exports__